<section>
  <app-form-header (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['statusCaption']" [translateValue]="true"></astral-input>
          <astral-input [control]="form.controls['receiverName']"></astral-input>
          <astral-input [control]="form.controls['phone']" [type]="'phone'"></astral-input>
        </astral-layout-group>
        <astral-textarea [control]="form.controls['message']" [rows]="12"></astral-textarea>
      </section>
    </form>
  }
</section>
